import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-9 w-full rounded-fd-sm bg-fd-surface-1 border border-fd-border',
        'px-3 py-1.5 font-geist text-[13.5px] text-fd-text placeholder:text-fd-text-subtle',
        'transition-[border,box-shadow] duration-fd-fast ease-fd-out',
        'focus-visible:outline-none focus-visible:border-fd-accent-line',
        'focus-visible:shadow-[0_0_0_3px_var(--fd-accent-soft)]',
        'disabled:opacity-50 disabled:pointer-events-none',
        'file:border-0 file:bg-transparent file:text-[13px] file:font-medium',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
